


export class KSBT {
  "costCenter";
  "costCtrShortText";
  "activityType";
  "actTypeShortText";
  "activityUnit";
  "fxdPricesInOCrcy";
  "objectCurrency";
  "totalPrice";
  "coAreaCurrency";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `KSBT`.
   */
  static getModelName() {
    return "KSBT";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of KSBT for dynamic purposes.
  **/
  static factory(data) {
    return new KSBT(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'KSBT',
      plural: 'KSBTs',
      path: 'KSBTs',
      properties: {
        "costCenter": {
          name: 'costCenter',
          type: 'string'
        },
        "costCtrShortText": {
          name: 'costCtrShortText',
          type: 'string'
        },
        "activityType": {
          name: 'activityType',
          type: 'string'
        },
        "actTypeShortText": {
          name: 'actTypeShortText',
          type: 'string'
        },
        "activityUnit": {
          name: 'activityUnit',
          type: 'string'
        },
        "fxdPricesInOCrcy": {
          name: 'fxdPricesInOCrcy',
          type: 'string'
        },
        "objectCurrency": {
          name: 'objectCurrency',
          type: 'string'
        },
        "totalPrice": {
          name: 'totalPrice',
          type: 'string'
        },
        "coAreaCurrency": {
          name: 'coAreaCurrency',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/KSBT.js